$ = jQuery.noConflict();

const cards = () => {
	const blockCards = $('.block-cards');

	blockCards.each(function () {
		const cardsPerLine = $(this).css('--cardsPerRow');

		const rowCards = $(this).find('.block-card');

		for (let i = 0; i < rowCards.length; i += cardsPerLine) {
			const cardsInLine = rowCards.slice(i, i + cardsPerLine);

			$(cardsInLine).css('--titleMinHeight', '0px');

			let titleHeight = 0;
			$(cardsInLine).each(function () {
				if ($(this).find('.wp-block-heading').height() > titleHeight) {
					titleHeight = $(this).find('.wp-block-heading').height();
				}
			});

			$(cardsInLine).css('--titleMinHeight', titleHeight + 'px');
		}
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		cards();
	},
	loaded() {},
	resized() {
		cards();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
